module.exports = __webpack_public_path__ + "static/media/fb.8a1ab14a.svg";